<template>
    <div class="col-md-6 col-sm-12">
        <div class="search-result-row">
            <div class="search-result-img" style="display: revert">
                <div style="width: 100%; height: 100%;  overflow: hidden;"
                     class="search-result-left img-scale-in podcastImg">
                    <a :href="currentUrl"><img :src="podcast.blob.url" alt=""></a>
                </div>
                <div class="search-result-right" style="margin-top: 20px; padding-left: 0; width: 100%">
                    <a :href="currentUrl">
                        <h2 style="color: var(--cdl-black); border-bottom: revert; font-size: 20px; line-height: revert; font-weight: 600; text-transform: revert">
                            {{ podcast.podcast_languages[0].pivot.title }} </h2>

                    </a>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
export default {
    name: "Podcast",
    props: {
        podcast: {
            type: Object,
            default: null
        }
    },
    computed: {
        // add playing param to current url keeping old params
        currentUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('playing', this.podcast.id);
            return `${window.location.pathname}?${urlParams.toString()}`;

        }

    }
}
</script>

<style scoped>
.podcastImg {
    display: grid;
    border-radius: 25px;
}
</style>
